import Button from '@Components/Buttons/Button'
import React, { useContext } from 'react'
import { StoresContext } from '@App/contexts'
import { useFlag } from '@openfeature/react-sdk'
import { OverclaimBulkActionType } from '@App/stores/overclaim/overclaim-search-bulk-action-store'

const BeginBulkAction = () => {
    const { overclaimSearchBulkActionStore } = useContext(StoresContext)
    const { value: showBulkRelinquishment } = useFlag('overclaim-bulk-relinquishment', false)
    const { value: showBulkDocument } = useFlag('overclaim-bulk-document', false)
    const { value: showBulkAmendment } = useFlag('overclaim-bulk-amendment', false)

    const handleStartBulkAction = (actionType: OverclaimBulkActionType) => {
        overclaimSearchBulkActionStore.setActiveBulkAction(actionType)
    }

    if (!showBulkRelinquishment && !showBulkDocument && !showBulkAmendment) {
        return null
    }

    return (
        <div className="bulk-action-start">
            {showBulkRelinquishment && (
                <Button
                    className="start-bulk-action"
                    mainColor
                    type="secondary"
                    onClick={() => handleStartBulkAction(OverclaimBulkActionType.Relinquishment)}
                >
                    Submit Bulk Relinquishments
                </Button>
            )}
            {showBulkDocument && (
                <Button
                    className="start-bulk-action"
                    mainColor
                    type="secondary"
                    onClick={() => handleStartBulkAction(OverclaimBulkActionType.DocumentUpload)}
                >
                    Submit Bulk Document Upload
                </Button>
            )}
            {showBulkAmendment && (
                <Button
                    className="start-bulk-action"
                    mainColor
                    type="secondary"
                    onClick={() => handleStartBulkAction(OverclaimBulkActionType.AmendmentSelection)}
                >
                    Submit Bulk Share Amendment
                </Button>
            )}
        </div>
    )
}
export default BeginBulkAction
